import { query } from '../utilities';

export const basketAdd = (productId,isMobile=false) => {
    return query('/basket/add/', { data: { productId, isMobile} });
};
